import React from 'react';

const CreateMilestone = ({ data }) => {
    return (
        <div className="d-flex align-items-center history-heading">
            {data?.milestone_name}
        </div>
    );
};

export default CreateMilestone; 